var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{cover: _vm.cover, loaded: _vm.loaded},attrs:{"loading":"lazy","decoding":"async","draggable":"false","src":_vm.src,"width":_vm._width,"height":_vm._height},on:{"load":function($event){_vm.loaded = true; _vm.$emit('load')}}})}
var staticRenderFns = []

export { render, staticRenderFns }